/** @format */

import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import { useNavigate, useParams } from "react-router-dom";
import EditNoteIcon from "@mui/icons-material/EditNote";
import AddUpdateProduct from "./AddUpdateProduct";
import { toast } from "react-toastify";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import { red } from "@mui/material/colors";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import ImageCarousel from "./ImageCarousel";
import { Tooltip } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import axios from "axios";

const Product = () => {
  const navigate = useNavigate();
  const { productId } = useParams();
  const [isFetching, setIsFetching] = useState(false);
  const [productDetails, setProductDetails] = useState([]);
  const [editMode, setEditMode] = useState(false);

  async function getProductDetailsByProductid() {
    setIsFetching(true);
    try {
      const productData = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/v1/product/getProduct?productId=${productId}`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
        }
      );
      console.log(productData.data);
      setProductDetails(productData.data);
      setIsFetching(false);
    } catch (err) {
      console.log(err);
    }
  }

  async function deleteProduct(productId) {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/v1/product/removeProducts`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
          data: [productId],
        }
      );
      console.log(response.data);
      navigate("/dashboard");
      toast.success(`product successfully deleted`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      console.log(err);
      toast.error(`${err.message}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }

  useEffect(() => {
    console.log(editMode);
  }, [editMode]);

  useEffect(() => {
    getProductDetailsByProductid();
  }, []);

  return (
    <>
      {!editMode ? (
        <>
          {isFetching ? (
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={true}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          ) : (
            <>
              <Alert
                icon={false}
                severity="success"
                color="success"
                sx={{ my: 2 }}
              >
                <Typography component="h1" variant="h6">
                  Product Details
                </Typography>
              </Alert>
              <Card sx={{ minWidth: 745 }}>
                <CardHeader
                  avatar={
                    <Avatar
                      sx={{ bgcolor: red[500] }}
                      aria-label="product-details"
                    >
                      {productDetails?.productName?.charAt(0)}
                    </Avatar>
                  }
                  title={productDetails?.productName}
                  subheader={productDetails?.productId}
                />
                <CardMedia
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  title="product images"
                >
                  {productDetails?.productImages?.length === 0 ? (
                    "No Image associated with this Product yet!"
                  ) : (
                    <ImageCarousel photos={productDetails?.productImages} />
                  )}
                </CardMedia>

                <CardContent
                  sx={{ display: "flex", flexDirection: "column", gap: "8px" }}
                >
                  <Typography variant="subtitle1" color="primary">
                    Product Category :
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {productDetails?.category}
                  </Typography>
                  <Typography variant="subtitle1" color="primary">
                    Product Subcategory :
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {productDetails?.subCategory}
                  </Typography>
                  <Typography variant="subtitle1" color="primary">
                    Product Description :
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {productDetails?.productDesc}
                  </Typography>
                  <Typography variant="subtitle1" color="primary">
                    Product Specification Type :
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {productDetails?.physicalSpec && (
                      <Chip
                        color="secondary"
                        variant="outlined"
                        label="Physical"
                      />
                    )}
                    {productDetails?.chemicalSpec && (
                      <Chip
                        color="secondary"
                        variant="outlined"
                        label="Chimical"
                      />
                    )}
                  </Typography>
                  <Typography variant="subtitle1" color="primary">
                    Product Specification Details :
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {productDetails?.specificationDet}
                  </Typography>
                  <Typography variant="subtitle1" color="primary">
                    Product Color :
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {productDetails?.color}
                  </Typography>
                  <Typography variant="subtitle1" color="primary">
                    Loadability :
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {productDetails?.loadability}
                    {" " + productDetails?.loadUnit}
                  </Typography>
                  <Typography variant="subtitle1" color="primary">
                    Product Packaging Description :
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {productDetails?.packagingDescription}
                  </Typography>
                </CardContent>

                <CardActions
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "20px",
                  }}
                >
                  <Tooltip title="Edit Product">
                    <IconButton
                      sx={{
                        bgcolor: red[500],
                        color: "white",
                        "&:hover": { color: "black" },
                      }}
                      aria-label="edit mode"
                      onClick={() => setEditMode(true)}
                    >
                      <ModeEditIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete Product">
                    <IconButton
                      sx={{
                        bgcolor: red[500],
                        color: "white",
                        "&:hover": { color: "black" },
                      }}
                      aria-label="delete product"
                      onClick={() => deleteProduct(productId)}
                    >
                      <DeleteForeverIcon />
                    </IconButton>
                  </Tooltip>
                </CardActions>
              </Card>
            </>
          )}
        </>
      ) : (
        <AddUpdateProduct
          header="Update Product Details"
          productDetails={productDetails}
          headerLogo={<EditNoteIcon />}
        />
      )}
    </>
  );
};

export default Product;
